import React, { useState, useEffect } from 'react'
import AddPurchase from './add_purchase';
import axios from 'axios';

const PurchaseBill = ({
  id,
  handleToast,
  closeLoading,
  handleLoading,
  toggleHeader,
}) => {
  const [showPurchase, setShowPurchase] = useState(false);
const [purchase, setPurchase] = useState([]);

    useEffect(() => {
      axios
        .get(`https://api.dectwinhotel.com/api/${id}_purchase_bill/get-purchase`)
        .then((response) => {
          setPurchase(response.data);
          // localStorage.setItem("purchase_bill", JSON.stringify(response.data));
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
        });
  }, [id]);


const handleAdjust = async (billId, totalAmt) => {

  handleLoading();

  try {
    const res = await axios.put(
      `https://api.dectwinhotel.com/api/${id}_purchase_bill/adjust-amount`,
      {
        billId: billId,
        amount_paid: totalAmt,
      }
    );


    console.log(res);
    if(res.status === 200) {
    const updatedPurchase = purchase.map(p =>
      p.id == billId
        ? { ...p, amount_paid: totalAmt }
        : p
    );

    setPurchase(updatedPurchase);
    // localStorage.setItem("purchase_bill", JSON.stringify(updatedPurchase));
      handleToast({
        toastMsg: "Bill Adjusted Successfully!!!",
        toastColor: "#4CAF50",
      });

}
  } catch (error) {
    console.error(error);
      handleToast({
        toastMsg: "Something went wrong! Please check input data or internet.",
        toastColor: "#FF0000",
      });
  } finally {
    closeLoading();
  }
};


  return (
    <>
      <section
        style={{
          backgroundColor: "#282c34",
          padding: "4rem 1rem",
        }}
      >

        {!showPurchase &&
          <div className="reports-page">
            <div className="position-absolute" style={{ right: "28px" }}>
              <button
                style={{ backgroundColor: "blue", marginLeft: "20px" }}
                className="fetch-btn"
                onClick={() => { setShowPurchase(true); toggleHeader() }}
              //   onClick={exportToExcel}
              >
                Add Purchase &nbsp; <i className="fa-solid fa-sheet-plastic"></i>
              </button>
            </div>
            <h2 className="text-start">Purchase History</h2>


          {purchase.length > 0 && (
            <div className="table-responsive">
              <table className="reports-table">
                <thead>
                  <tr>
                    <th>SNo</th>
                    <th>Date</th>
                    <th>Party Name</th>
                    <th>Contact</th>
                    <th>Address</th>
                    <th>Items</th>
                    <th>Total Amount</th>
                    <th>Amount Paid</th>
                    <th>Pay Method</th>
                    <th>Activity</th>
                  </tr>
                </thead>
                <tbody>
                  {purchase.map((report) => (
                    <tr key={report.id}>
                      <td>{report.id}</td>
<td>
  {new Date(report.date).toLocaleDateString('en-GB')}
</td>
                      <td>{report.party_name}</td>
                      <td>{report.party_mobile}</td>
                      <td>{report.party_address}</td>
<td>
  {JSON.parse(report.items).map((item, index) => (
    <div key={index}>
      {item.itemName} × {item.quantity}<br />
    </div>
  ))}
</td>
                      <td>₹{report.total_amount}</td>
                      <td>₹{report.amount_paid}</td>
                      <td>{report.pay_method}</td>
                                          <td className='text-center'>
                                            {report.total_amount == report.amount_paid ? '-' : <i
                                title="Adjust Amount Paid"
                              class="fa-solid fa-circle-dot"
                              onClick={() => handleAdjust(report.id, report.total_amount)}
                                style={{
                                    fontSize: "18px",
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                              ></i>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          </div>
        }

        {showPurchase && (
          <AddPurchase
            id={id}
            setShowPurchase={setShowPurchase}
            handleToast={handleToast}
            closeLoading={closeLoading}
            handleLoading={handleLoading}
          />
        )}
      </section>
    </>
  )
}

export default PurchaseBill